import { render } from "./PieChart.vue?vue&type=template&id=40056c1a&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"

import "./PieChart.vue?vue&type=style&index=0&id=40056c1a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40056c1a"]])

export default __exports__